import { useQuery } from '@tanstack/react-query';

import { browserApiClient, requiredApiData } from './browser-api';

export async function loadCodexConstellations(signal?: AbortSignal) {
  const response = await browserApiClient().GET('/api/v1/codex/constellations', { signal });
  return requiredApiData(response.data, response.error, 'Your constellations could not be loaded.');
}

export type CodexConstellation = Awaited<
  ReturnType<typeof loadCodexConstellations>
>['constellations'][number];

export function useCodexConstellations(enabled: boolean) {
  return useQuery({
    queryKey: ['player', 'codex-constellations', 'v1'],
    queryFn: ({ signal }) => loadCodexConstellations(signal),
    enabled,
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
